<script>
	module.exports = {
		props: ['product', 'subArticle', 'assignmentId'],
		components: {
			'video-content': require('components/video-content.vue').default,
			'content-footer': require('components/routes/student-workspace/content-footer.vue').default
		},
		computed: {
			selectedProduct: function () {
				return this.subArticle || this.product;
			},
			eventData() {
				let aid = this.assignmentId;

				return { aid };
			}
		}
	};
</script>
<template>
	<div class="main-content wrapper video">
		<div class="main-content-article rte">
			<video-content
				:video="selectedProduct.video"
				:event-data="eventData"></video-content>
		</div>
		<content-footer :selected-product="selectedProduct"> </content-footer>
	</div>
</template>
